const TOOLS = [
  {
    name: "list_alerts",
    scope: "mcp:alerts:read",
    desc: "List alerts with optional filters: status, alert product (Ethoca, CDRN, RDR), business account, and date range."
  },
  {
    name: "get_alert",
    scope: "mcp:alerts:read",
    desc: "Retrieve the full details of a single alert by its ID."
  },
  {
    name: "list_business_accounts",
    scope: "mcp:business_accounts:read",
    desc: "List business accounts, optionally filtered by status or name, with optional enrollment and descriptor details."
  },
  {
    name: "get_business_account",
    scope: "mcp:business_accounts:read",
    desc: "Retrieve the full details of a single business account by its ID, including enrollments and descriptors."
  },
  {
    name: "change_alert_status",
    scope: "mcp:alerts:write",
    desc: "Change the status of a single alert. Changing an alert's status works the same as on the platform and follows the same rules and restrictions. This is a write action, so it requires a write permission that you confirm during setup, and it is a separate tool from the read-only tools above. If you have security concerns, you can decline the write permission and use the MCP with read-only functionality only."
  }
]

const ToolsTable = () => (
  <>
    {/* Desktop table */}
    <table className="mcp-doc-tools-table">
      <thead>
        <tr>
          <th style={{ width: 210 }}>Tool</th>
          <th style={{ width: 200 }}>Scope required</th>
          <th>What it does</th>
        </tr>
      </thead>
      <tbody>
        {TOOLS.map((tool) => (
          <tr key={tool.name}>
            <td>
              <span className="mcp-doc-tool-name">{tool.name}</span>
            </td>
            <td>
              <span className="mcp-doc-scope-chip">{tool.scope}</span>
            </td>
            <td>{tool.desc}</td>
          </tr>
        ))}
      </tbody>
    </table>

    {/* Mobile cards */}
    <div className="mcp-doc-tools-cards">
      {TOOLS.map((tool) => (
        <div key={tool.name} className="mcp-doc-tools-card">
          <div className="mcp-doc-tools-card-header">
            <span className="mcp-doc-tool-name">{tool.name}</span>
            <span className="mcp-doc-scope-chip">{tool.scope}</span>
          </div>
          <p className="mcp-doc-tools-card-desc">{tool.desc}</p>
        </div>
      ))}
    </div>
  </>
)

export default ToolsTable
